import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      window?.scrollTo({ left: 0, top: 0, behavior: "auto" });
    } catch (error) {
      console.error(error);
    }
  }, [pathname]);

  return null;
};

const useScrollTop = ScrollTop;
export default useScrollTop;
